import { render, staticRenderFns } from "./InventoryDiscrepancy.vue?vue&type=template&id=2941c980&"
import script from "./InventoryDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./InventoryDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports